<h1 mat-dialog-title>Suscripción exitosa!</h1>
<div mat-dialog-actions>
    <button mat-button mat-dialog-close>Aceptar</button>
</div>